import { AttackPattern, PatternState } from '../AttackPattern.js';
import { ARENA } from '../../../../config/constants.js';

/**
 * Sovereign's Wrath — exclusive to The Unmade King. Radial bullet rings
 * erupt from the boss *and* from all 4 arena corners at once — reuses
 * Skyfall's "attack from a fixed location, not the boss" technique, applied
 * to the arena's corners instead of the player's recent positions, for an
 * arena-wide beat rather than a boss-centered one.
 *
 * `config` (ringCount/damage/speed/cornerMargin) is per-boss tuning,
 * supplied by data/bosses.js.
 */
export class SovereignsWrath extends AttackPattern {
  constructor({ minPhase = 0, config }) {
    super({ name: "Sovereign's Wrath", telegraphDuration: 0.9, activeDuration: 0.2, minPhase });
    this.config = config;
  }

  onBegin(boss) {
    const { cornerMargin } = this.config;
    this._origins = [
      { x: boss.x, y: boss.y },
      { x: ARENA.x + cornerMargin, y: ARENA.y + cornerMargin },
      { x: ARENA.x + ARENA.width - cornerMargin, y: ARENA.y + cornerMargin },
      { x: ARENA.x + cornerMargin, y: ARENA.y + ARENA.height - cornerMargin },
      { x: ARENA.x + ARENA.width - cornerMargin, y: ARENA.y + ARENA.height - cornerMargin },
    ];
  }

  onActiveStart(_boss, _player, pool) {
    const { ringCount, damage, speed } = this.config;
    for (const origin of this._origins) {
      for (let i = 0; i < ringCount; i++) {
        const angle = (i / ringCount) * Math.PI * 2;
        pool.fire({
          x: origin.x,
          y: origin.y,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed,
          radius: 2.5,
          damage,
          color: '#ffe27a',
          lifetime: 3,
        });
      }
    }
  }

  // Reuses the 'echoTelegraph' visual kind — dashed rings at each origin
  // (boss + 4 corners), same as Riven Choir's Echo Chorus preview.
  getVisual() {
    if (this.state !== PatternState.TELEGRAPH) return null;
    return { kind: 'echoTelegraph', echoes: this._origins };
  }
}
